import { styled as muiStyled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { hover, primary500, thirdly2, thirdly4, thirdly6, white } from 'styles/theme'

const textPrimary = 'var(--Text-primary, #404F69)'
const textSecondary = 'var(--Text-secondary, #7E8A9E)'
const neutralBorder = 'var(--Button-Neutral-border-primary, #E3E8F0)'
const neutralText = `var(--Button-Neutral-text-primary, ${primary500})`
const pageRegularApp = `var(--Surface-page-Regular-app, ${hover})`
const processingText = `var(--Status-Processing-text, ${thirdly6})`

export const closedBg = 'var(--Status-Closed-bg, #E3E8F0)'
export const closedText = 'var(--Status-Closed-text, #5F6E86)'

export const DashboardTopSectionStyles = muiStyled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    rowGap: 25,
    color: textPrimary,
    lineHeight: "normal",

    //  כותרת 
    '.top-header': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        columnGap: 16,
    },
    '.top-header-texts': {
        display: "flex",
        flexDirection: "column",
        rowGap: 12,
    },
    '.top-title': {
        fontSize: 30,
        fontWeight: 700,
    },
    '.top-subtitle': {
        fontSize: 20,
        b: { fontWeight: 700 },
    },

    //   הקוביות 
    '.top-cards': {
        display: "grid",
        gridTemplateColumns: "minmax(0, 511fr) repeat(3, minmax(0, 271fr))",
        gap: 16,
        padding: 16,
        background: `var(--Surface-card-primary-default, ${white})`,
        borderRadius: 16,
        boxSizing: "border-box",
        [theme.breakpoints.down('xl')]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: "minmax(0, 1fr)",
        },
    },

    //  קובייה כללית 
    '.top-card': {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "stretch",
        rowGap: 25,
        minHeight: 194,
        padding: 16,
        border: `1px solid ${neutralBorder}`,
        borderRadius: 16,
        boxSizing: "border-box",
        minWidth: 0,
    },
    '.top-card-head': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        columnGap: 8,
    },
    '.top-card-title': {
        fontSize: 20,
        fontWeight: 700,
    },
    '.top-card-icon': {
        width: 36,
        height: 36,
        boxSizing: "border-box",
        padding: 8,
        borderRadius: 10,
        background: pageRegularApp,
        color: processingText,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        i: { fontSize: 14 },
    },
    '.top-card-value': {
        fontSize: 40,
        fontWeight: 700,
    },

    //  כפתורי pill 
    '.pill-btn': {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        columnGap: 8,
        padding: "4px 12px",
        borderRadius: 999,
        border: `1px solid ${neutralBorder}`,
        background: `var(--Button-Neutral-bg-primary, ${white})`,
        color: neutralText,
        fontSize: 16,
        lineHeight: "normal",
        fontFamily: "inherit",
        cursor: "pointer",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        '&:hover:not(:disabled)': { filter: "brightness(0.97)" },
        '&:disabled': { cursor: "default" },
        i: { fontSize: 14 },
    },
    // הכפתור התחתון נצמד למטה בקובייה
    '.pill-btn.full': {
        width: "100%",
        marginTop: "auto",
    },
    // כפתור inline  - "לביצוע המבדקים".     
    '.pill-btn.inline': {
        flex: "0 1 234px",
        minWidth: 0,
        background: `var(--Button-Inline-bg-primary, ${thirdly4})`,
        borderColor: `var(--Button-Inline-border-primary, ${thirdly2})`,
        color: neutralText,
    },
    // כפתור - "הדרכות וכללים"
    '.pill-btn.main': {
        borderRadius: 8,
        padding: "8px 16px",
        border: "none",
        background: `var(--Button-Main-bg-primary, ${primary500})`,
        color: `var(--Button-Main-text-primary, ${white})`,
    },

    //  קוביית "דורש טיפול" 
    '.attention-card': {
        rowGap: 14,
    },
    '.attention-row': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        columnGap: 8,
        padding: "10px 14px",
        background: white,
        border: `1px solid ${neutralBorder}`,
        borderRadius: 12,
        fontSize: 16,
        b: { fontWeight: 700 },
        '.pill-btn': { flexShrink: 0 },
    },
    '.attention-text': {
        display: "flex",
        alignItems: "center",
        columnGap: 6,
        minWidth: 0,
        i: { fontSize: 14, color: processingText, flexShrink: 0 },
    },

    //  קוביית ההתקדמות 
    '.progress-card': {
        background: pageRegularApp,
        rowGap: 18,
    },
    '.progress-section': {
        display: "flex",
        flexDirection: "column",
        rowGap: 5,
    },
    '.progress-main': {
        display: "flex",
        alignItems: "center",
        columnGap: 8,
        minHeight: 41,
    },
    '.progress-of': {
        fontSize: 20,
        fontWeight: 700,
    },
    '.muted-small': {
        fontSize: 14,
        fontWeight: 400,
        color: textSecondary,
    },
    '.progress-track': {
        height: 7,
        borderRadius: 6,
        background: `var(--Neutral-50, ${white})`,
        overflow: "hidden",
    },
    '.progress-fill': {
        height: "100%",
        borderRadius: 6,
        background: 'var(--Info-2-400, #85B6FF)',
        transition: "width 0.6s ease",
    },
    '.progress-bottom': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        columnGap: 12,
    },
    '.progress-remaining': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        minWidth: 0,
        color: textSecondary,
    },
    '.remaining-main': {
        fontSize: 16,
        fontWeight: 700,
    },
}))
